import React from 'react'
import OrderShapedQueue from '../shared/OrderShapedQueue'

const ZatcaQueue = () => <OrderShapedQueue queue="zatca" title="Zatca" />

export default ZatcaQueue
